module.exports = __webpack_public_path__ + "public/img/Kopi.87595493.png";